import { _ as _type_of } from "@swc/helpers/_/_type_of";
var y = Object.defineProperty;
var u = function(t) {
    return y(t, "__esModule", {
        value: !0
    });
};
var d = typeof require != "undefined" ? require : function(t) {
    throw new Error('Dynamic require of "' + t + '" is not supported');
};
var p = function(t, o) {
    u(t);
    for(var s in o)y(t, s, {
        get: o[s],
        enumerable: !0
    });
};
p(exports, {
    default: function() {
        return c;
    }
});
var i = new WeakMap;
var b = 0;
function c(t) {
    var o = typeof t === "undefined" ? "undefined" : _type_of(t), s = t && t.constructor, f = s == Date;
    var e, n;
    if (Object(t) === t && !f && s != RegExp) {
        if (e = i.get(t), e) return e;
        if (e = ++b + "~", i.set(t, e), s == Array) {
            for(e = "@", n = 0; n < t.length; n++)e += c(t[n]) + ",";
            i.set(t, e);
        }
        if (s == Object) {
            e = "#";
            var l = Object.keys(t).sort();
            for(; typeof (n = l.pop()) != "undefined";)typeof t[n] != "undefined" && (e += n + ":" + c(t[n]) + ",");
            i.set(t, e);
        }
    } else e = f ? t.toJSON() : o == "symbol" ? t.toString() : o == "string" ? JSON.stringify(t) : "" + t;
    return e;
}
